var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealEstate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40584"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40579"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47304",
    d: "M-1078.628 300.669c-.542-.4-.691-.766-.464-1.18a.927.927 0 0 1 .928-.442c2.169.006 4.338 0 6.507 0h.559v-45.683a4.51 4.51 0 0 1 .039-.661.766.766 0 0 1 .742-.678 3.45 3.45 0 0 1 .427-.009h20.279c1 0 1.213.221 1.213 1.237v18.232h11.012c.914 0 1.148.235 1.149 1.151v26.414h1.118c1.14 0 2.28.018 3.419-.008a1.132 1.132 0 0 1 1.145.581v1.044zm19.691-1.633v-26.213c0-1.148.186-1.337 1.31-1.337h7.575V253.67h-19.394v45.351h2.409v-.543c0-2.185-.005-4.37 0-6.555a2.43 2.43 0 0 1 2.531-2.6c.427-.014.855-.007 1.282 0a2.446 2.446 0 0 1 2.663 2.7V299.038zm1.651-.019h19.387V273.13h-19.387zm-4.945.009a.492.492 0 0 0 .041-.119c0-2.373.011-4.745 0-7.118a.774.774 0 0 0-.832-.836c-.427-.02-.854-.01-1.281-.007-.864 0-1.118.264-1.118 1.144v6.936z",
    transform: "translate(1080.195 -251.016)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47305",
    d: "M-1054.029 264.275c.712 0 1.423-.006 2.135 0 .779.008 1.069.287 1.074 1.052q.013 2.205 0 4.412c0 .73-.313 1.025-1.053 1.029q-2.206.011-4.412 0c-.709 0-1.021-.306-1.027-1.007q-.016-2.229 0-4.459c0-.717.3-1.011 1.007-1.023.758-.015 1.517-.004 2.276-.004zm-1.628 1.659v3.177h3.189v-3.177z",
    transform: "translate(1078.574 -251.924)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47306",
    d: "M-1059.586 267.55c0 .743.006 1.487 0 2.23-.008.665-.29.98-.94.985q-2.3.022-4.6 0a.838.838 0 0 1-.933-.95q-.012-2.3 0-4.6a.815.815 0 0 1 .9-.93q2.349-.028 4.7 0c.6.007.871.32.88.941.001.774-.007 1.549-.007 2.324zm-1.648 1.576v-3.193h-3.179v3.193z",
    transform: "translate(1079.222 -251.924)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47307",
    d: "M-1054.081 262c-.759 0-1.518.009-2.277 0-.638-.011-.944-.293-.951-.925q-.026-2.3 0-4.6c.006-.65.326-.95.981-.954q2.254-.014 4.506 0c.682 0 .994.3 1 .983q.02 2.254 0 4.507c-.006.712-.3.984-1.03.992-.748.004-1.487-.003-2.229-.003zm1.608-1.643v-3.193h-3.182v3.193z",
    transform: "translate(1078.574 -251.275)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47308",
    d: "M-1062.8 279.519c-.775 0-1.55.007-2.324 0a.832.832 0 0 1-.939-.937q-.012-2.3 0-4.6a.826.826 0 0 1 .941-.931q2.3-.011 4.6 0a.815.815 0 0 1 .931.933q.012 2.3 0 4.6a.823.823 0 0 1-.933.935c-.757.008-1.517 0-2.276 0zm1.567-4.821h-3.177v3.178h3.177z",
    transform: "translate(1079.222 -252.574)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47309",
    d: "M-1066.064 258.739c0-.744-.005-1.486 0-2.23.006-.679.307-.989.987-.993q2.254-.014 4.506 0c.682 0 .978.306.982.992q.01 2.254 0 4.507c0 .7-.282.978-.982.982q-2.253.014-4.505 0c-.711 0-.985-.3-.989-1.03s.001-1.485.001-2.228zm4.83 1.617v-3.192h-3.18v3.192z",
    transform: "translate(1079.222 -251.275)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47310",
    d: "M-1059.586 285.022c0 .759.006 1.518 0 2.278-.008.673-.281.965-.945.969q-2.3.018-4.6 0a.824.824 0 0 1-.928-.944q-.012-2.3 0-4.6a.829.829 0 0 1 .9-.931q2.349-.022 4.7 0a.808.808 0 0 1 .872.9c.01.779 0 1.554.001 2.328zm-1.643-1.577h-3.191v3.175h3.191z",
    transform: "translate(1079.222 -253.222)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47311",
    d: "M-1040.977 291.785c-.728 0-1.455.009-2.182 0s-1.014-.3-1.019-1.011q-.015-2.229 0-4.459c0-.708.312-1.016 1.015-1.02q2.229-.015 4.459 0c.706 0 1.013.306 1.018 1.015q.016 2.23 0 4.46c0 .719-.3 1-1.013 1.016-.761.008-1.519-.001-2.278-.001zm-1.58-4.846c0 1.013-.009 1.988.016 2.961 0 .089.217.241.337.245.646.025 1.294.012 1.94.013h.925v-3.219z",
    transform: "translate(1077.601 -253.481)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47312",
    d: "M-1046.452 288.525c0 .758.007 1.518 0 2.277-.007.67-.28.97-.943.977q-2.3.024-4.6 0a.828.828 0 0 1-.93-.947q-.013-2.3 0-4.6a.838.838 0 0 1 .948-.935q2.3-.021 4.6 0c.625.007.916.324.924.953.008.756.001 1.515.001 2.275zm-4.8-1.588v3.2h3.153v-3.2z",
    transform: "translate(1078.249 -253.481)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47313",
    d: "M-1040.951 283.017c-.759 0-1.518.006-2.277 0-.629-.007-.941-.293-.947-.928q-.025-2.3 0-4.6c.007-.651.327-.939.986-.942q2.253-.008 4.506 0c.683 0 .99.293 1 .981q.021 2.253 0 4.506c-.006.709-.307.981-1.034.986-.748.001-1.491-.003-2.234-.003zm1.612-1.645v-3.178h-3.178v3.178z",
    transform: "translate(1077.601 -252.833)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47314",
    d: "M-1040.93 300.547c-.743 0-1.486.006-2.229 0-.706-.007-1.014-.3-1.019-1.015q-.015-2.229 0-4.459c.005-.718.3-1 1.015-1.008q2.229-.012 4.459 0c.722 0 1.013.286 1.018 1q.016 2.229 0 4.459c0 .73-.314 1.015-1.061 1.02-.728.007-1.453.003-2.183.003zm1.6-4.836h-3.192v3.18h3.192z",
    transform: "translate(1077.601 -254.132)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47315",
    d: "M-1049.69 283.017c-.759 0-1.518.006-2.277 0-.661-.007-.958-.3-.961-.959q-.011-2.276 0-4.554a.842.842 0 0 1 .966-.958q2.277-.01 4.554 0c.658 0 .951.3.955.962q.011 2.278 0 4.554c0 .666-.293.947-.958.955-.761.006-1.52 0-2.279 0zm1.581-1.643V278.2h-3.179v3.177z",
    transform: "translate(1078.249 -252.833)",
    style: {
      fill: "#65c6f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47316",
    d: "M-1046.452 297.287c0 .759.007 1.518 0 2.277-.007.68-.3.977-.994.981q-2.229.011-4.459 0c-.718 0-1.02-.3-1.022-1.006q-.008-2.254 0-4.507c0-.663.292-.963.953-.968q2.3-.017 4.6 0c.638.006.912.3.921.945.009.76.001 1.519.001 2.278zm-1.661 1.619v-3.2h-3.168v3.2z",
    transform: "translate(1078.249 -254.132)",
    style: {
      fill: "#65c6f1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3444",
    style: {
      fill: "none"
    },
    d: "M0 0h50v50H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstate);
export default __webpack_public_path__ + "static/media/RealEstate.508bee9f34715c0115dfbddc99a0aebd.svg";
export { ForwardRef as ReactComponent };